import api from "../../service/api"
import routes from "../../service/apiRoutes"

export const getSurvey = (surveyId) => api.get(routes.survey, { params: { survey_id: surveyId }, noauth: true })
export const getSurveyBlock = (surveyId) => api.get(routes.surveyBlock, { params: { survey_id: surveyId }, noauth: true })
